import { useMutation, useQuery, useQueryClient } from "api";

const SHOP_API_URL = process.env.REACT_APP_SHOP_API_URL || "http://localhost:8000/api";

// 1. QUERY KEY FACTORY
// We centralize keys so the Mutation can update the exact key the Query listens to.
export const certificateQueries = {
  all: () => ["certificates"],
  detail: (orderId, zipCode) => ["certificates", "detail", orderId, zipCode],
};

// 2. MUTATION HOOK (send zip code to receive order details)
export const useVerifyCertificate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ orderId, zipCode }) => {
      const response = await fetch(`${SHOP_API_URL}/collectors/orders/${orderId}/certificate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          zip_code: zipCode,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.detail ||
            "Unable to verify order. Please check your information and try again.",
        );
      }
      return response.json();
    },

    onSuccess: (data, variables) => {
      console.log("onSuccess", data, variables);
      const { orderId, zipCode } = variables;
      queryClient.setQueryData(certificateQueries.detail(orderId, zipCode), data);
    },
  });
};

export const useCertificate = (orderId, zipCode) =>
  useQuery({
    queryKey: certificateQueries.detail(orderId, zipCode),
    queryFn: async ({ queryKey }) => {
      const response = await fetch(`${SHOP_API_URL}/collectors/orders/${orderId}/certificate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          zip_code: zipCode,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));

        // Return user-friendly message
        throw new Error(
          errorData.detail ||
            "Unable to verify order. Please check your information and try again.",
        );
      }

      return response.json();
    },
    retry: false,
    enabled: !!zipCode && !!orderId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
